/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Relation_Competitor_DescInputs */

const en_site_relation_competitor_desc = /** @type {(inputs: Site_Relation_Competitor_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You want to beat it`)
};

const id_site_relation_competitor_desc = /** @type {(inputs: Site_Relation_Competitor_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamu mau lebih baik darinya`)
};

/**
* | output |
* | --- |
* | "You want to beat it" |
*
* @param {Site_Relation_Competitor_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_relation_competitor_desc = /** @type {((inputs?: Site_Relation_Competitor_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Relation_Competitor_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_relation_competitor_desc(inputs)
	return en_site_relation_competitor_desc(inputs)
});